import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SiteService } from "../../services/site.translation.service";
import { TranslationKeys } from "../../interface/site.interface";

interface TranslationState {
  data: TranslationKeys | null;
  status: number | null;
  loading: boolean;
}

const initialState: TranslationState = {
  data: null,
  status: null,
  loading: false,
};
export const fetchTranslation = createAsyncThunk(
  "translation/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const result = await SiteService.GetSiteTranslation();
      return result;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const translationDataSlice = createSlice({
  name: "translationData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTranslation.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.status = action.payload.status;
        state.loading = false;
      })
      .addCase(fetchTranslation.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default translationDataSlice.reducer;
